import { useQuery } from '@apollo/client';
import { getCookies } from '@edx/frontend-platform/i18n/lib';

import { GET_ORG_ID_BY_NAME } from '../queries/cart';

export const useOrgId = () => {
  const orgName = getCookies().get('orgName');

  const { data } = useQuery(GET_ORG_ID_BY_NAME, {
    variables: { orgName },
    skip: !orgName,
  });

  return data?.organisations?.[0]?.id || null;
};
